import {
  CardActions,
  CardContent,
  CardHeader,
  createStyles,
  IconButton,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import {
  Camera as CameraIcon,
  Check,
  Close,
  Refresh
} from '@material-ui/icons';

import { ICameraStore } from './CameraStore';

import { IRouteStore } from '../../RouteStore';


const styles = (theme: Theme) => createStyles({
  actions: {
    alignContent: 'center',
    display: 'flex',
  },
  button: {
    margin: 'auto'
  },
  canvas: {
    margin: 'auto',
    'max-width': '100%',
    width: '512px'
  },
  hidden: {
    display: 'none'
  },
  video: {
    margin: 'auto',
    'max-width': '100%',
    width: '512px'
  }
});

declare type stylesKeys = 'actions' | 'button' | 'canvas' | 'hidden' | 'video';

declare interface ICameraProps extends InjectedIntlProps {
  camera: ICameraStore;
  routes: IRouteStore;
}

@observer
class Camera extends React.Component<ICameraProps & WithStyles<stylesKeys>, {}> {

  public componentDidMount() {
    const { camera } = this.props;

    camera.startVideo(this.video);
  }

  public componentWillUnmount() {
    this._stop();
  }

  public componentDidCatch() {
    this._stop();
  }

  public render() {
    const { camera, classes, intl: { formatMessage } } = this.props;
    return <React.Fragment>
      <CardHeader
        action={
          <IconButton onClick={this._handleClose}>
            <Close/>
          </IconButton>
        }
        title={formatMessage({id: 'camera.title'})}
      />
      <CardContent>
        <video id="video" autoPlay={true} playsInline={true} className={[
          classes.video,
          camera.videoIsRunning ? '' : classes.hidden
          ].join(' ')}/>
        <canvas id="photo" className={[
          classes.canvas,
          (camera.photoIsTaken && !camera.videoIsRunning) ? '' : classes.hidden
          ].join(' ')}/>
      </CardContent>
      <CardActions className={classes.actions} disableActionSpacing={true}>
        {camera.photoIsTaken
          ? <React.Fragment>
              <IconButton className={classes.button} onClick={this._handleDrop}>
                <Refresh/>
              </IconButton>
              <IconButton className={classes.button} onClick={this._handleAccept}>
                <Check/>
              </IconButton>
            </React.Fragment>
          : <IconButton className={classes.button} onClick={this._handlePhoto}>
              <CameraIcon/>
            </IconButton>
        }
      </CardActions>
    </React.Fragment>;
  }

  private get video() {
    return document.getElementById('video') as HTMLVideoElement;
  }

  private get photo() {
    return document.getElementById('photo') as HTMLCanvasElement;
  }

  private _handleClose = () => {
    const { routes } = this.props;
    this._handleDrop();
    this._stop();
    routes.navigate('diary-meal-add');
  }

  private _handleDrop = () => {
    const { camera } = this.props;
    camera.dropPhoto();
  }

  private _handleAccept = () => {
    const { camera, routes } = this.props;
    camera.acceptPhoto();
    routes.navigate('diary-meal-add');

  }

  private _handlePhoto = () => {
    const { camera } = this.props;
    camera.takePhoto(this.video, this.photo);
  }

  private _stop = () => {
    const { camera } = this.props;
    camera.stopVideo(this.video);
  }

}

export default withStyles<stylesKeys>(styles)(injectIntl<WithStyles<stylesKeys> & InjectedIntlProps>(inject('camera', 'routes')(Camera)));



// WEBPACK FOOTER //
// ./src/components/camera/CameraView.tsx